import { render, staticRenderFns } from "./AddEditFreeDayModal.vue?vue&type=template&id=106345fc&scoped=true&"
import script from "./AddEditFreeDayModal.vue?vue&type=script&lang=js&"
export * from "./AddEditFreeDayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106345fc",
  null
  
)

export default component.exports